import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { TranslocoRootModule } from './transloco-root.module';
import { MaintenanceComponent } from './core/maintenance/maintenance.component';

import { LayoutModule } from './modules/layout/layout.module';
import { ErrorService } from './core/services/error.service';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { AuthModule } from './modules/login/auth.module';
import { PrivacyPolicyComponent } from './core/privacy-policy/privacy-policy.component';
import { TermsOfServiceComponent } from './core/terms-of-service/terms-of-service.component';
import { DeleteAccountInstructionsComponent } from './core/delete-account-instructions/delete-account-instructions.component';
import {LiveFeedComponent} from "./core/live-feed/live-feed.component";
import { UserManualComponent } from './core/user-manual/user-manual.component';
import { VerifyEmailComponent } from './core/verify-email/verify-email.component';

@NgModule({
  declarations: [
    AppComponent,
    MaintenanceComponent,
    PrivacyPolicyComponent,
    TermsOfServiceComponent,
    LiveFeedComponent,
    DeleteAccountInstructionsComponent,
    UserManualComponent,
    VerifyEmailComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    BrowserAnimationsModule,
    HttpClientModule,
    TranslocoRootModule,
    AuthModule,
    LayoutModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: ErrorService, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    { provide: MAT_DATE_LOCALE, useValue: 'hr-HR' },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
